import BaseColors from '@/atoms/colors/Base';
import Shadow from '@/atoms/colors/Shadow';
import { brand, core } from '@/lib/theme/tokens/palettes';

const TooltipColors = Object.freeze({
  primary: {
    backgroundColor: brand.blue.main,
    color: core.white,
  },
  secondary: {
    backgroundColor: core.white,
    color: BaseColors.font.primary,
    boxShadow: `${Shadow.mid}, 0 1px 0 0 ${BaseColors.border.primary}77`,
  },
  tertiary: {
    backgroundColor: brand.grey.shades[2],
    color: core.white,
  },
});

export default TooltipColors;
